export { InputArea } from './InputArea';
export * from './InputArea.types';
